(function(){
  if (window.__frwCartArrivalLoaded) return;
  window.__frwCartArrivalLoaded = true;

  var ENDPOINT = 'https://cortex.freedomravewear.com/api/arrival-estimate';
  var ZIP_COOKIE = 'frw_zip';

  function readCookie(name){
    var match = document.cookie.match(new RegExp('(^|;\\s*)' + name + '=([^;]+)'));
    return match ? decodeURIComponent(match[2]) : null;
  }
  function fmtShortDate(iso){
    try {
      var d = new Date(iso + 'T12:00:00Z');
      return d.toLocaleDateString('en-US', { weekday:'short', month:'short', day:'numeric', timeZone:'UTC' });
    } catch(e){ return iso; }
  }

  function fetchArrivalForVariant(variantId, productId, zip){
    var qs = ['variantId=' + encodeURIComponent(variantId)];
    if (productId) qs.push('shopifyId=' + encodeURIComponent(productId));
    if (zip) qs.push('zip=' + encodeURIComponent(zip));
    return fetch(ENDPOINT + '?' + qs.join('&'), { credentials: 'omit' })
      .then(function(r){ return r.ok ? r.json() : null; })
      .catch(function(){ return null; });
  }

  function render(latestArrival, hasInternational, hasPreorder, hasUnknown, mixedMto, latestNonMto, latestMto){
    var bars = document.querySelectorAll('[data-cart-arrival]');
    if (bars.length === 0) return;
    var msg = '';
    if (hasInternational) msg = 'International order — exact dates at checkout';
    else if (hasPreorder && !latestArrival) msg = 'Pre-order items will ship when released';
    // Dual-date copy ("In stock arrive by X · MTO arrive by Y") is gated until
    // Cortex supports auto-split fulfillment on mixed orders. Today, mixed
    // orders sit in hold until MTO production completes — promising two
    // shipments would be a lie. Fall through to the single-date variant.
    else if (mixedMto && latestArrival) msg = 'Your cart contains made to order items and will arrive by <strong>' + fmtShortDate(latestArrival) + '</strong>';
    else if (latestArrival && !hasUnknown) msg = 'All items arrive by <strong>' + fmtShortDate(latestArrival) + '</strong>';
    else if (latestArrival && hasUnknown) msg = 'Most items arrive by <strong>' + fmtShortDate(latestArrival) + '</strong> · some items have no date yet';
    else return;
    bars.forEach(function(bar){
      var t = bar.querySelector('[data-cart-arrival-text]');
      if (t) t.innerHTML = msg;
      bar.hidden = false;
    });
  }

  // Injects a "Made to Order" badge into each MTO line item in the cart.
  // Idempotent — safe to call on every render; existing badges are removed first.
  function renderLineBadges(perItem){
    var rows = document.querySelectorAll('tr.cart-items__table-row');
    rows.forEach(function(row){
      // Clear any prior badge first so we don't double-stamp after a drawer morph
      var prior = row.querySelector('.cart-arrival-line-badge');
      if (prior) prior.remove();

      var qs = row.querySelector('cart-quantity-selector-component[data-variant-id]');
      if (!qs) return;
      var vid = qs.getAttribute('data-variant-id');
      var info = perItem[vid];
      if (!info || !info.isMto) return;

      var titleEl = row.querySelector('td.cart-items__details > p');
      if (!titleEl) return;

      var badge = document.createElement('span');
      badge.className = 'cart-arrival-line-badge cart-arrival-line-badge--mto';
      badge.textContent = 'Made to Order';
      titleEl.insertAdjacentElement('afterend', badge);
    });
  }

  function update(){
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(cart){
        if (!cart || !cart.items || cart.items.length === 0){
          document.querySelectorAll('[data-cart-arrival]').forEach(function(b){ b.hidden = true; });
          document.querySelectorAll('.cart-arrival-line-badge').forEach(function(b){ b.remove(); });
          return;
        }
        var zip = readCookie(ZIP_COOKIE);
        var promises = cart.items.map(function(it){
          return fetchArrivalForVariant(String(it.variant_id), String(it.product_id), zip);
        });
        Promise.all(promises).then(function(results){
          var perItem = {};
          var latest = null, hasIntl = false, hasPre = false, hasUnknown = false;
          var hasMto = false, hasNonMto = false;
          var latestMto = null, latestNonMto = null;
          results.forEach(function(r, idx){
            var it = cart.items[idx];
            if (!r || !r.success) { hasUnknown = true; return; }
            if (it) perItem[String(it.variant_id)] = r;
            var d = r.arrivalDateMax || r.arrivalDate;
            if (r.isMto) {
              hasMto = true;
              if (d && (!latestMto || d > latestMto)) latestMto = d;
            } else {
              hasNonMto = true;
              if (d && (!latestNonMto || d > latestNonMto)) latestNonMto = d;
            }
            if (r.isInternational) hasIntl = true;
            if (r.isPreorder) hasPre = true;
            if (d) {
              if (!latest || d > latest) latest = d;
            } else if (!r.isInternational && !r.isPreorder) {
              hasUnknown = true;
            }
          });
          var mixedMto = hasMto && hasNonMto;
          render(latest, hasIntl, hasPre, hasUnknown, mixedMto, latestNonMto, latestMto);
          renderLineBadges(perItem);
        });
      });
  }

  var _updateScheduled = false;
  function scheduleUpdate(){
    if (_updateScheduled) return;
    _updateScheduled = true;
    setTimeout(function(){ _updateScheduled = false; update(); }, 250);
  }

  function init(){
    document.addEventListener('cart:updated', scheduleUpdate);
    document.addEventListener('cart:refresh', scheduleUpdate);
    window.addEventListener('shopify:cart:update', scheduleUpdate);
    window.addEventListener('onward:cart_changed', scheduleUpdate);

    var origFetch = window.fetch;
    window.fetch = function(input, init){
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var method = (init && init.method) || (input && input.method) || 'GET';
      var p = origFetch.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)/i.test(url) && /post/i.test(method)) {
        p.then(function(){ scheduleUpdate(); }).catch(function(){});
      }
      return p;
    };

    var drawer = document.querySelector('cart-drawer-component, cart-drawer, .cart-drawer');
    if (window.MutationObserver && drawer) {
      var mo = new MutationObserver(function(muts){
        for (var i = 0; i < muts.length; i++) {
          if (muts[i].type === 'childList' && (muts[i].addedNodes.length || muts[i].removedNodes.length)) {
            scheduleUpdate();
            return;
          }
        }
      });
      mo.observe(drawer, { childList: true, subtree: true });
    }

    if (document.querySelector('[data-cart-arrival]')) {
      update();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
